export default __webpack_public_path__ + "static/media/noResultsAll.2eb7d7c6.svg";